Backbone = require 'backbone'
qs = require 'querystring'
sd = require('sharify').data
_ = require('underscore')
FlashMessage = require '../flash/index.coffee'
modalize = require '../modalize/index.coffee'
mediator = require '../../lib/mediator.coffee'
template = -> require('./index.jade') arguments...
Form = require('../mixins/form.coffee')
FormErrorHelpers = require('../auth_modal/helpers')
{ repcaptcha } = require "@artsy/reaction/dist/Utils/repcaptcha"

class MarketingSignupModalInner extends Backbone.View
  _.extend @prototype, Form
  _.extend @prototype, FormErrorHelpers

  className: 'marketing-signup-modal'

  signupIntent: 'marketing modal'

  events:
    'click .auth-mode-toggle a': 'openLogin'
    'click #signup-fb': 'fbSignup'
    'submit form': 'onSubmit'

  initialize: ({@data}) ->
    @acquisitionInitiative = @data?.slug

  render: ->
    @$el.html template
      image: @data.image
      photoCredit: @data.photoCredit
      textColor: @data.textColor
      textOpacity: @data.textOpacity
      copy: @data.copy

    @$('#accepted_terms_of_service').on('invalid', @checkAcceptedTerms)

    this

  openLogin: (e) ->
    e.preventDefault()
    mediator.trigger 'open:auth',
      mode: 'login'
      intent: @signupIntent
      signupIntent: @signupIntent
      trigger: 'click'
      destination: location.href

    @trigger 'close'

  fbSignup: (e) ->
    e.preventDefault()
    queryData =
      'signup-intent': @signupIntent
      'signup-referer': location.href
      'redirect-to': '/personalize'
      'acquisition_initiative': "Marketing Modal #{@acquisitionInitiative}"
    queryString = $.param(queryData)
    fbUrl = sd.AP.facebookPath + '?' + queryString
    return window.location.href = fbUrl

  showFormError: (msg) =>
    @$('button').attr 'data-state', 'error'
    @showError(msg)

  showError: (msg) =>
    @$('.auth-errors').text msg

  submit: (recaptcha_token) =>
    formData = @serializeForm()
    data = Object.assign {},
      formData,
      @gdprData(formData),
      signupIntent: @signupIntent,
      signupReferer: @signupReferer
      acquisition_initiative: "Marketing Modal #{@acquisitionInitiative}"
      recaptcha_token: recaptcha_token

    $.ajax
      url: sd.AP.signupPagePath
      method: 'POST'
      data: data
      error: (e) =>
        err = e.responseJSON?.error or e.toString()
        @showFormError err
      success: =>
        @trigger 'close'
        flash = new FlashMessage message: 'Thank you for joining Artsy', href: '/personalize'
      complete: =>
        @$('form button').removeClass 'is-loading'

  onSubmit: (e) ->
    return unless @validateForm()
    return if @formIsSubmitting()
    e.preventDefault()
    @$('form button').addClass 'is-loading'
    repcaptcha("signup_submit", (token) =>
      @submit(token)
    )

module.exports = class MarketingSignupModal extends Backbone.View

  initialize: ->
    slug = qs.parse(location.search.replace /^\?/, '')?['m-id']

    # Launches marketing signup modal for targeted url
    slug = 'ca3' if !slug and sd.CURRENT_PATH is sd.TARGET_CAMPAIGN_URL

    return unless sd.MARKETING_SIGNUP_MODALS?
    modalData = _.findWhere(sd.MARKETING_SIGNUP_MODALS, { slug: slug })

    return unless modalData
    @inner = new MarketingSignupModalInner
      data: modalData

    @modal = modalize @inner, backdropCloses: false, dimensions: width: ''
    className = 'marketing-signup-modal-container'
    className += '-mobile' if sd.IS_MOBILE
    @modal.view.$el.addClass className
    @inner.on 'close', => @modal.close()

    loggedOut = not sd.CURRENT_USER?
    delayDuration = if modalData?.duration then modalData?.duration else 2000

    setTimeout @open, delayDuration if loggedOut and modalData?

  open: =>
    @modal.open()
    @inner.$('input:first').focus()
